import React, { useMemo } from "react";

import { FormBuilder, IFileUploadValue } from "shared/components";
import { IFormButtons, IImageItem } from "shared/types";
import { getImageURLWithStyle } from "shared/utils";
import { fields } from "./formData";

interface ImageFormProps {
  isSubmitting?: boolean;
  hasError?: boolean;
  defaultValues?: Record<string, any>;
  buttons?: IFormButtons;
  submitMode?: "isDirty";
  resetForm?: boolean;
  inlineForm?: boolean;
  handleSubmit: (image: Partial<IImageItem>) => void;
}

export const ImageForm: React.FC<ImageFormProps> = ({
  resetForm,
  handleSubmit,
  hasError,
  defaultValues,
  ...rest
}) => {
  const cleanDefaultValues = useMemo(
    () =>
      defaultValues
        ? {
            ...defaultValues,
            image: {
              originalURL: getImageURLWithStyle({
                imageStyles: defaultValues?.imageStyles,
              }),
            },
          }
        : undefined,
    [defaultValues]
  );

  const handleCleanSubmit = ({
    description,
    image,
  }: {
    description?: string;
    image: IFileUploadValue;
  }) => {
    const cleanValue: Partial<IImageItem> = {
      description,
      ...(image.file?.url
        ? {
            file: {
              url: image.file.url,
            },
          }
        : {}),
    };

    handleSubmit(cleanValue);
  };

  return (
    <FormBuilder
      fields={fields}
      onSubmit={handleCleanSubmit}
      defaultValues={cleanDefaultValues}
      globalError
      submitMode="isDirty"
      resetForm={resetForm}
      apiErrorMessage={hasError}
      {...rest}
    />
  );
};
